export interface AccessCardScan {
  refreshSpaces: boolean;
  refreshModels: boolean;
  seen: Set<string>;
}

/// Decide whether a poll's access cards are news, and for which list. Guarded
/// on ids already acted on rather than on the lists themselves: a reclassified
/// card names a space that is present both before AND after, so a state
/// comparison would re-fire the (FGA ListObjects-backed) space read on every
/// poll, forever.
///
/// One `seen` set spans both id lists, so a card counted for both — a space
/// grant moves the space list AND brings its models — is retired once.
///
/// `seen === null` is the first fetch, not an empty history — cards already
/// sitting in the bell must not cost a read on every mount.
export function scanAccessCards(
  spaceCardIds: string[],
  modelCardIds: string[],
  seen: Set<string> | null,
): AccessCardScan {
  const isNews = (ids: string[]): boolean =>
    seen !== null && ids.some((id) => !seen.has(id));
  return {
    refreshSpaces: isNews(spaceCardIds),
    refreshModels: isNews(modelCardIds),
    seen: new Set([...spaceCardIds, ...modelCardIds]),
  };
}
